export default "__VITE_ASSET__Dkv8frOb__"